import React from "react";
import { useLocation, useParams } from "react-router-dom";
import { Card, Col, Row } from "react-bootstrap";

import ListingPageContainer from "Common/Components/PageContainer/ListingPageContainer";
import EnquiryLogPage from "../EnquiryListing/SalesListing/EnquiryLog";
import ProductQuotationLog from "../QuotationListing/SalesListing/ProductQuotationContainer";
import ServiceQuotationLog from "../QuotationListing/ServiceListing/ServiceQuotationContainer";
import PaymentManagementProductListing from "../PaymentMangmentListing/Product/Listing";
import PaymentManagementServiceListing from "../PaymentMangmentListing/Service/Listing";
import ProductSalesOrderLog from "../OrderListing/SalesListing/SalesOrderLog";
import ServiceSalesOrderLog from "../OrderListing/ServiceListing/ServiceLog";
import PurchaseRequestListing from "../PurchaseRequest/List/PurchaseRequest";
import PurchaseOrderListing from "../PurchaseOrderListing/List";
import WarehousePacking from "../PackingListing";
import WarehouseDispatch from "../DispatchListing/List/Dispatch";
import InboxIcon from "@mui/icons-material/Inbox";

type TagSearchLocationState = { tagSearchNonce?: number };

const MainListing: React.FC = () => {
  const { tags } = useParams<{ tags?: string }>();
  const location = useLocation();
  const tagSearchNonce =
    (location.state as TagSearchLocationState | null)?.tagSearchNonce ?? 0;

  const searchTerm = React.useMemo(() => {
    if (!tags) return "";
    try {
      return decodeURIComponent(tags).trim();
    } catch {
      return tags.trim();
    }
  }, [tags]);
  const modulesRef = React.useRef<HTMLDivElement | null>(null);
  const [showNoDataFallback, setShowNoDataFallback] = React.useState(false);

  React.useEffect(() => {
    const node = modulesRef.current;
    if (!node) return;

    const updateFallback = () => {
      setShowNoDataFallback(node.children.length === 0);
    };

    updateFallback();
    const observer = new MutationObserver(updateFallback);
    observer.observe(node, { childList: true, subtree: false });
    return () => observer.disconnect();
  }, [searchTerm, tagSearchNonce]);

  return (
    <ListingPageContainer>
      <Row>
        <Col lg={12}>
          <Card className="shadow-none mb-4">

            <Card.Body>
              <div
                ref={modulesRef}
                key={`tag-search-modules-${searchTerm}-${tagSearchNonce}`}
              >
              {/* {searchTerm && (
                  <div className="mb-3 d-flex flex-wrap gap-2">
                    <span
                      className="badge bg-light text-dark border"
                      style={{ fontSize: "0.75rem" }}
                    >
                      {searchTerm}
                    </span>
                  </div>
                )} */}

                {/* Purchase Request */}
                <PurchaseRequestListing noWrapper />

                {/* Purchase Order */}
                <PurchaseOrderListing noWrapper />

                {/* Enquiry – Sales (product) */}
                <EnquiryLogPage type="product" noWrapper />

                {/* Enquiry – Service */}
                <EnquiryLogPage type="service" noWrapper />

                {/* Quotation – Product */}
                <ProductQuotationLog noWrapper />

                {/* Quotation – Service */}
                <ServiceQuotationLog noWrapper />

                {/* Sales Order – Product */}
                <ProductSalesOrderLog type="product" noWrapper />

                {/* Sales Order – Service */}
                <ServiceSalesOrderLog type="service" noWrapper />

                {/* Payment Management – Product */}
                <PaymentManagementProductListing noWrapper />

                {/* Payment Management – Service */}
                <PaymentManagementServiceListing noWrapper />

                {/* Packing */}
                <WarehousePacking noWrapper />

                {/* Dispatch */}
                <WarehouseDispatch noWrapper />
              </div>

              {showNoDataFallback && (
                <div className="py-5 text-center text-muted">
                  <InboxIcon sx={{ fontSize: 56, opacity: 0.6, mb: 1 }} />
                  <div style={{ fontSize: "16px", fontWeight: 500 }}>
                    No data found for this tag
                  </div>
                  <div style={{ fontSize: "14px", opacity: 0.85 }}>
                    Try searching with another tag
                  </div>
                </div>
              )}

            </Card.Body>
          </Card>
        </Col>
      </Row>
    </ListingPageContainer>
  );
};

export default MainListing;